import { Outlet } from "react-router-dom";
import AppShell from "components/app/AppShell";

const ProjectsLayout = () => {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
};

export default ProjectsLayout;
